import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotellistloader',
  templateUrl: './hotellistloader.component.html',
  styleUrls: ['./hotellistloader.component.css']
})
export class HotellistloaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
